import h from 'react-hyperscript';

export default ({ location }) =>
  h('not-found', [h('h1', '404'), h('p', 'You seem to be lost. The resource you are looking for could not be found.')]);



// WEBPACK FOOTER //
// ./src/pages/NotFound/NotFound.js